'use client';
import {Container} from "@web-libs/ui/layout-components/container";
import {CSSProperties, useEffect} from "react";
import {RoundButton} from "@web-libs/ui/ui-components/buttons/round-button";
import NavIcon from "@web-libs/ui/svgs/icons/NavIcon";
import {ContentSlide} from "@web-libs/ui/ui-components/slider/content-slider.types";
import {useContentSlider} from "@web-libs/ui/ui-components/slider/use-content-slider.concern";
import ContentSliderStyles from "./content-slider.module.css"
import {ContentSliderEmpty} from "@web-libs/ui/ui-components/slider/content-slider-empty";
import {ContentSliderBar} from "@web-libs/ui/ui-components/slider/content-slider-bar";
import {Text} from "@web-libs/ui/ui-components/typo/text";
import {Headline} from "@web-libs/ui/ui-components/typo/headline";
import { getCssVar } from '@web-libs/features/colors/application/colors';

export type ContentSliderProps = {
    topLeftText: string;
    contentSlides: ContentSlide[];
    onNavClick?: (navId?: string) => void;
    style?: CSSProperties;
}

export const ContentSlider = ({topLeftText, contentSlides, onNavClick, style}: ContentSliderProps) => {

    if (typeof window !== 'undefined') {
        //Preload images
        contentSlides.forEach((slide, index) => {
            if (slide.background) {
                const image = new Image()
                image.src = slide.background
            }
        })
    }

    const {
        currentSlide,
        navigateToSlide,
        getCurrentSlideIndex,
        onNavigationClick,
        startSlideShow,
        stopSlideShow
    } = useContentSlider(contentSlides, onNavClick)

    useEffect(() => {
        startSlideShow(5000)
        return () => stopSlideShow()
    }, [])

    if (contentSlides.length === 0 || !currentSlide) {
        return <ContentSliderEmpty></ContentSliderEmpty>
    }

    const contentSliderStyles: CSSProperties = getContentSliderStyles(currentSlide!)
    const className = `${ContentSliderStyles.contentSliderShared} ${ContentSliderStyles.contentSlider}`
    const classNameTopRow = `${ContentSliderStyles.contentSliderTopRow}`
    const classNameBottomRow = `${ContentSliderStyles.contentSliderBottomRow}`


    return (
        <Container className={className} padding={32} style={{...contentSliderStyles, ...style}}>
            <div className={classNameTopRow}>
                <div><Text size={'md'}>{topLeftText}</Text></div>
                <RoundButton color={"light"} svg={NavIcon} onClick={onNavigationClick}/>
            </div>
            <div className={classNameBottomRow}>
                <div>
                    <div><Text size={'md'}>{currentSlide?.secondaryText}</Text></div>
                    <div style={{marginBottom: 15}}><Headline size={'md'}>{currentSlide?.mainText}</Headline></div>
                    <ContentSliderBar count={contentSlides.length} activeIndex={getCurrentSlideIndex()}
                                      onClick={navigateToSlide}></ContentSliderBar>
                </div>
            </div>
        </Container>
    )
}

export const getBackground = (contentSlide: ContentSlide) => {
  return `linear-gradient(0deg, rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0.5)),url(${contentSlide?.background})`
}

export const getContentSliderStyles = (contentSlide: ContentSlide) => {
  const styles = {
    backgroundSize: "cover",
    backgroundPosition: "center",
    color: getCssVar("light")
  }
  if(contentSlide.background){
    return {
      ...styles,
      backgroundImage: getBackground(contentSlide)
    }
  } else {
    return {
      ...styles,
      backgroundColor: getCssVar("dark")
    }
  }
}
